var _regeneratorRuntime = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _slicedToArray = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e29) { throw _e29; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e30) { didErr = true; err = _e30; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

!function (e, t) {
  "object" == typeof exports && "undefined" != typeof module ? t(exports) : "function" == typeof define && define.amd ? define(["exports"], t) : t((e = "undefined" != typeof globalThis ? globalThis : e || self).toGeoJSON = {});
}(this, function (e) {
  "use strict";

  var _marked = /*#__PURE__*/_regeneratorRuntime.mark(g),
      _marked2 = /*#__PURE__*/_regeneratorRuntime.mark(y),
      _marked3 = /*#__PURE__*/_regeneratorRuntime.mark(M);

  function t(e) {
    return e && e.normalize && e.normalize(), e && e.textContent || "";
  }

  function n(e, t) {
    var n = e.getElementsByTagName(t);
    return n.length ? n[0] : null;
  }

  function o(e) {
    var o = {};

    if (e) {
      var _s = n(e, "line");

      if (_s) {
        var _e = t(n(_s, "color")),
            _r = parseFloat(t(n(_s, "opacity"))),
            _i = parseFloat(t(n(_s, "width")));

        _e && (o.stroke = _e), isNaN(_r) || (o["stroke-opacity"] = _r), isNaN(_i) || (o["stroke-width"] = 96 * _i / 25.4);
      }
    }

    return o;
  }

  function s(e, o) {
    var s = {};
    var r, i;

    for (i = 0; i < o.length; i++) {
      r = n(e, o[i]), r && (s[o[i]] = t(r));
    }

    return s;
  }

  function r(e) {
    var n = s(e, ["name", "cmt", "desc", "type", "time", "keywords"]),
        o = e.getElementsByTagNameNS("http://www.garmin.com/xmlschemas/GpxExtensions/v3", "*");

    for (var _s2 = 0; _s2 < o.length; _s2++) {
      var _r2 = o[_s2];
      _r2.parentNode.parentNode === e && (n[_r2.tagName.replace(":", "_")] = t(_r2));
    }

    var r = e.getElementsByTagName("link");
    r.length && (n.links = []);

    for (var _e2 = 0; _e2 < r.length; _e2++) {
      n.links.push(Object.assign({
        href: r[_e2].getAttribute("href")
      }, s(r[_e2], ["text", "type"])));
    }

    return n;
  }

  function i(e) {
    var o = [parseFloat(e.getAttribute("lon")), parseFloat(e.getAttribute("lat"))],
        s = n(e, "ele"),
        r = n(e, "gpxtpx:hr") || n(e, "hr"),
        i = n(e, "time");
    var l;
    s && (l = parseFloat(t(s)), isNaN(l) || o.push(l));
    var a = {
      coordinates: o,
      time: i ? t(i) : null,
      extendedValues: []
    };
    r && a.extendedValues.push(["heart", parseFloat(t(r))]);
    var c = n(e, "extensions");
    if (null !== c) for (var _i2 = 0, _arr = ["speed", "course", "hAcc", "vAcc"]; _i2 < _arr.length; _i2++) {
      var _e3 = _arr[_i2];

      var _o = parseFloat(t(n(c, _e3)));

      isNaN(_o) || a.extendedValues.push([_e3, _o]);
    }
    return a;
  }

  function l(e) {
    var t = a(e, "rtept");
    if (t) return {
      type: "Feature",
      properties: Object.assign(r(e), o(n(e, "extensions")), {
        _gpxType: "rte"
      }),
      geometry: {
        type: "LineString",
        coordinates: t.line
      }
    };
  }

  function a(e, t) {
    var n = e.getElementsByTagName(t);
    if (n.length < 2) return;
    var o = [],
        s = [],
        r = {};

    for (var _e4 = 0; _e4 < n.length; _e4++) {
      var _t = i(n[_e4]);

      o.push(_t.coordinates), _t.time && s.push(_t.time);

      for (var _o2 = 0; _o2 < _t.extendedValues.length; _o2++) {
        var _t$extendedValues$_o = _slicedToArray(_t.extendedValues[_o2], 2),
            _s3 = _t$extendedValues$_o[0],
            _i3 = _t$extendedValues$_o[1],
            _l = "heart" === _s3 ? _s3 : _s3 + "s";

        r[_l] || (r[_l] = Array(n.length).fill(null)), r[_l][_e4] = _i3;
      }
    }

    return {
      line: o,
      times: s,
      extendedValues: r
    };
  }

  function c(e) {
    var t = e.getElementsByTagName("trkseg"),
        s = [],
        i = [],
        l = [];

    for (var _e5 = 0; _e5 < t.length; _e5++) {
      var _n = a(t[_e5], "trkpt");

      _n && (l.push(_n), _n.times && _n.times.length && i.push(_n.times));
    }

    if (0 === l.length) return;
    var c = l.length > 1,
        g = Object.assign(r(e), o(n(e, "extensions")), {
      _gpxType: "trk"
    }, i.length ? {
      coordinateProperties: {
        times: c ? i : i[0]
      }
    } : {});

    for (var _e6 = 0; _e6 < l.length; _e6++) {
      var _t2 = l[_e6];
      s.push(_t2.line);

      for (var _i4 = 0, _Object$entries = Object.entries(_t2.extendedValues); _i4 < _Object$entries.length; _i4++) {
        var _Object$entries$_i = _slicedToArray(_Object$entries[_i4], 2),
            _n2 = _Object$entries$_i[0],
            _o3 = _Object$entries$_i[1];

        var _t3 = g;
        "heart" === _n2 && (g.coordinateProperties || (g.coordinateProperties = {}), _t3 = g.coordinateProperties), c ? (_t3[_n2] || (_t3[_n2] = l.map(function (e) {
          return new Array(e.line.length).fill(null);
        })), _t3[_n2][_e6] = _o3) : _t3[_n2] = _o3;
      }
    }

    return {
      type: "Feature",
      properties: g,
      geometry: c ? {
        type: "MultiLineString",
        coordinates: s
      } : {
        type: "LineString",
        coordinates: s[0]
      }
    };
  }

  function g(e) {
    var t, n, o, _e7, _n3, _e8, _t4, _e9, a;

    return _regeneratorRuntime.wrap(function g$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            t = e.getElementsByTagName("trk"), n = e.getElementsByTagName("rte"), o = e.getElementsByTagName("wpt");
            _e7 = 0;

          case 2:
            if (!(_e7 < t.length)) {
              _context.next = 11;
              break;
            }

            _n3 = c(t[_e7]);
            _context.t0 = _n3;

            if (!_context.t0) {
              _context.next = 8;
              break;
            }

            _context.next = 8;
            return _n3;

          case 8:
            _e7++;
            _context.next = 2;
            break;

          case 11:
            _e8 = 0;

          case 12:
            if (!(_e8 < n.length)) {
              _context.next = 21;
              break;
            }

            _t4 = l(n[_e8]);
            _context.t1 = _t4;

            if (!_context.t1) {
              _context.next = 18;
              break;
            }

            _context.next = 18;
            return _t4;

          case 18:
            _e8++;
            _context.next = 12;
            break;

          case 21:
            _e9 = 0;

          case 22:
            if (!(_e9 < o.length)) {
              _context.next = 28;
              break;
            }

            _context.next = 25;
            return a = o[_e9], {
              type: "Feature",
              properties: Object.assign(r(a), s(a, ["sym"])),
              geometry: {
                type: "Point",
                coordinates: i(a).coordinates
              }
            };

          case 25:
            _e9++;
            _context.next = 22;
            break;

          case 28:
          case "end":
            return _context.stop();
        }
      }
    }, _marked);
  }

  var u = [["heartRate", "heartRates"], ["Cadence", "cadences"], ["Speed", "speeds"], ["Watts", "watts"]],
      m = [["TotalTimeSeconds", "totalTimeSeconds"], ["DistanceMeters", "distanceMeters"], ["MaximumSpeed", "maxSpeed"], ["AverageHeartRateBpm", "avgHeartRate"], ["MaximumHeartRateBpm", "maxHeartRate"], ["AvgSpeed", "avgSpeed"], ["AvgWatts", "avgWatts"], ["MaxWatts", "maxWatts"]];

  function p(e, o) {
    var s = [];

    var _iterator = _createForOfIteratorHelper(o),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var _step$value = _slicedToArray(_step.value, 2),
            _r3 = _step$value[0],
            _i5 = _step$value[1];

        var _o4 = n(e, _r3);

        if (!_o4) {
          var _t5 = e.getElementsByTagNameNS("http://www.garmin.com/xmlschemas/ActivityExtension/v2", _r3);

          _t5.length && (_o4 = _t5[0]);
        }

        var _l2 = parseFloat(t(_o4));

        isNaN(_l2) || s.push([_i5, _l2]);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }

    return s;
  }

  function h(e) {
    var o = t(n(e, "LongitudeDegrees")),
        s = t(n(e, "LatitudeDegrees"));
    if (!o.length || !s.length) return null;
    var r = [parseFloat(o), parseFloat(s)],
        i = n(e, "AltitudeMeters"),
        l = n(e, "HeartRateBpm"),
        a = n(e, "Time");
    var c;
    return i && (c = parseFloat(t(i)), isNaN(c) || r.push(c)), {
      coordinates: r,
      time: a ? t(a) : null,
      heartRate: l ? parseFloat(t(l)) : null,
      extensions: p(e, u)
    };
  }

  function f(e, t) {
    var n = e.getElementsByTagName(t),
        o = [],
        s = [],
        r = [];
    if (n.length < 2) return null;
    var i = {
      extendedProperties: {}
    };

    for (var _e10 = 0; _e10 < n.length; _e10++) {
      var _t6 = h(n[_e10]);

      if (null !== _t6) {
        o.push(_t6.coordinates), _t6.time && s.push(_t6.time), _t6.heartRate && r.push(_t6.heartRate);

        var _iterator2 = _createForOfIteratorHelper(_t6.extensions),
            _step2;

        try {
          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            var _step2$value = _slicedToArray(_step2.value, 2),
                _o5 = _step2$value[0],
                _s4 = _step2$value[1];

            i.extendedProperties[_o5] || (i.extendedProperties[_o5] = Array(n.length).fill(null)), i.extendedProperties[_o5][_e10] = _s4;
          }
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }
      }
    }

    return Object.assign(i, {
      line: o,
      times: s,
      heartRates: r
    });
  }

  function d(e) {
    var o = e.getElementsByTagName("Track"),
        s = [],
        r = [],
        i = [],
        l = [];
    var a;

    var c = function (e) {
      var t = {};

      var _iterator3 = _createForOfIteratorHelper(e),
          _step3;

      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var _step3$value = _slicedToArray(_step3.value, 2),
              _n4 = _step3$value[0],
              _o6 = _step3$value[1];

          t[_n4] = _o6;
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }

      return t;
    }(p(e, m)),
        g = n(e, "Name");

    g && (c.name = t(g));

    for (var _e11 = 0; _e11 < o.length; _e11++) {
      a = f(o[_e11], "Trackpoint"), a && (s.push(a.line), a.times.length && r.push(a.times), a.heartRates.length && i.push(a.heartRates), l.push(a.extendedProperties));
    }

    for (var _e12 = 0; _e12 < l.length; _e12++) {
      var _t7 = l[_e12];

      for (var _n5 in _t7) {
        1 === o.length ? c[_n5] = a.extendedProperties[_n5] : (c[_n5] || (c[_n5] = s.map(function (e) {
          return Array(e.length).fill(null);
        })), c[_n5][_e12] = _t7[_n5]);
      }
    }

    if (0 !== s.length) return (r.length || i.length) && (c.coordinateProperties = Object.assign(r.length ? {
      times: 1 === s.length ? r[0] : r
    } : {}, i.length ? {
      heart: 1 === s.length ? i[0] : i
    } : {})), {
      type: "Feature",
      properties: c,
      geometry: {
        type: 1 === s.length ? "LineString" : "MultiLineString",
        coordinates: 1 === s.length ? s[0] : s
      }
    };
  }

  function y(e) {
    var t, _e13, _n6, n, _e14, _t8;

    return _regeneratorRuntime.wrap(function y$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            t = e.getElementsByTagName("Lap");
            _e13 = 0;

          case 2:
            if (!(_e13 < t.length)) {
              _context2.next = 11;
              break;
            }

            _n6 = d(t[_e13]);
            _context2.t0 = _n6;

            if (!_context2.t0) {
              _context2.next = 8;
              break;
            }

            _context2.next = 8;
            return _n6;

          case 8:
            _e13++;
            _context2.next = 2;
            break;

          case 11:
            n = e.getElementsByTagName("Courses");
            _e14 = 0;

          case 13:
            if (!(_e14 < n.length)) {
              _context2.next = 22;
              break;
            }

            _t8 = d(n[_e14]);
            _context2.t1 = _t8;

            if (!_context2.t1) {
              _context2.next = 19;
              break;
            }

            _context2.next = 19;
            return _t8;

          case 19:
            _e14++;
            _context2.next = 13;
            break;

          case 22:
          case "end":
            return _context2.stop();
        }
      }
    }, _marked2);
  }

  var N = /\s*/g,
      x = /^\s*|\s*$/g,
      T = /\s+/;

  function b(e) {
    if (!e || !e.length) return 0;
    var t = 0;

    for (var _n7 = 0; _n7 < e.length; _n7++) {
      t = (t << 5) - t + e.charCodeAt(_n7) | 0;
    }

    return t;
  }

  function S(e) {
    return e.replace(N, "").split(",").map(parseFloat);
  }

  function k(e) {
    return e.replace(x, "").split(T).map(S);
  }

  function A(e) {
    if (void 0 !== e.xml) return e.xml;

    if (e.tagName) {
      var _t9 = e.tagName;

      for (var _n8 = 0; _n8 < e.attributes.length; _n8++) {
        _t9 += e.attributes[_n8].name + e.attributes[_n8].value;
      }

      for (var _n9 = 0; _n9 < e.childNodes.length; _n9++) {
        _t9 += A(e.childNodes[_n9]);
      }

      return _t9;
    }

    return "#text" === e.nodeName ? (e.nodeValue || e.value || "").trim() : "#cdata-section" === e.nodeName ? e.nodeValue : "";
  }

  var B = ["Polygon", "LineString", "Point", "Track", "gx:Track"];

  function E(e, o, s) {
    var r = t(n(o, "color")) || "";
    var i = "stroke" == s || "fill" === s ? s : s + "-color";
    "#" === r.substr(0, 1) && (r = r.substr(1)), 6 === r.length || 3 === r.length ? e[i] = r : 8 === r.length && (e[s + "-opacity"] = parseInt(r.substr(0, 2), 16) / 255, e[i] = "#" + r.substr(6, 2) + r.substr(4, 2) + r.substr(2, 2));
  }

  function F(e, o, s, r) {
    var i = parseFloat(t(n(o, s)));
    isNaN(i) || (e[r] = i);
  }

  function P(e) {
    var n = e.getElementsByTagName("coord");
    var o = [],
        s = [];
    0 === n.length && (n = e.getElementsByTagName("gx:coord"));

    for (var _e15 = 0; _e15 < n.length; _e15++) {
      o.push(t(n[_e15]).split(" ").map(parseFloat));
    }

    var r = e.getElementsByTagName("when");

    for (var _e16 = 0; _e16 < r.length; _e16++) {
      s.push(t(r[_e16]));
    }

    return {
      coords: o,
      times: s
    };
  }

  function v(e) {
    var o, s, r, i, l;
    var a = [],
        c = [];
    if (n(e, "MultiGeometry")) return v(n(e, "MultiGeometry"));
    if (n(e, "MultiTrack")) return v(n(e, "MultiTrack"));
    if (n(e, "gx:MultiTrack")) return v(n(e, "gx:MultiTrack"));

    for (r = 0; r < B.length; r++) {
      if (s = e.getElementsByTagName(B[r]), s) for (i = 0; i < s.length; i++) {
        if (o = s[i], "Point" === B[r]) a.push({
          type: "Point",
          coordinates: S(t(n(o, "coordinates")))
        });else if ("LineString" === B[r]) a.push({
          type: "LineString",
          coordinates: k(t(n(o, "coordinates")))
        });else if ("Polygon" === B[r]) {
          var _e17 = o.getElementsByTagName("LinearRing"),
              _s5 = [];

          for (l = 0; l < _e17.length; l++) {
            _s5.push(k(t(n(_e17[l], "coordinates"))));
          }

          a.push({
            type: "Polygon",
            coordinates: _s5
          });
        } else if ("Track" === B[r] || "gx:Track" === B[r]) {
          var _e18 = P(o);

          a.push({
            type: "LineString",
            coordinates: _e18.coords
          }), _e18.times.length && c.push(_e18.times);
        }
      }
    }

    return {
      geoms: a,
      coordTimes: c
    };
  }

  function L(e, o, s, r) {
    var i = v(e);
    var l;
    var a = {},
        c = t(n(e, "name")),
        g = t(n(e, "address"));
    var u = t(n(e, "styleUrl"));
    var m = t(n(e, "description")),
        p = n(e, "TimeSpan"),
        h = n(e, "TimeStamp"),
        f = n(e, "ExtendedData");
    var d = n(e, "IconStyle"),
        y = n(e, "LabelStyle"),
        N = n(e, "LineStyle"),
        x = n(e, "PolyStyle");
    var T = n(e, "visibility");

    if (c && (a.name = c), g && (a.address = g), u) {
      "#" !== u[0] && (u = "#" + u), a.styleUrl = u, o[u] && (a.styleHash = o[u]), s[u] && (a.styleMapHash = s[u], a.styleHash = o[s[u].normal]);
      var _e19 = r[a.styleHash];
      _e19 && (d || (d = n(_e19, "IconStyle")), y || (y = n(_e19, "LabelStyle")), N || (N = n(_e19, "LineStyle")), x || (x = n(_e19, "PolyStyle")));
    }

    if (m && (a.description = m), p) {
      var _e20 = t(n(p, "begin")),
          _o7 = t(n(p, "end"));

      a.timespan = {
        begin: _e20,
        end: _o7
      };
    }

    if (h && (a.timestamp = t(n(h, "when"))), d) {
      E(a, d, "icon"), F(a, d, "scale", "icon-scale"), F(a, d, "heading", "icon-heading");

      var _e21 = n(d, "hotSpot");

      if (_e21) {
        var _t10 = parseFloat(_e21.getAttribute("x")),
            _n10 = parseFloat(_e21.getAttribute("y"));

        isNaN(_t10) || isNaN(_n10) || (a["icon-offset"] = [_t10, _n10]);
      }

      var _o8 = n(d, "Icon");

      if (_o8) {
        var _e22 = t(n(_o8, "href"));

        _e22 && (a.icon = _e22);
      }
    }

    if (y && (E(a, y, "label"), F(a, y, "scale", "label-scale")), N && (E(a, N, "stroke"), F(a, N, "width", "stroke-width")), x) {
      E(a, x, "fill");

      var _e23 = t(n(x, "fill")),
          _o9 = t(n(x, "outline"));

      _e23 && (a["fill-opacity"] = "1" === _e23 ? a["fill-opacity"] || 1 : 0), _o9 && (a["stroke-opacity"] = "1" === _o9 ? a["stroke-opacity"] || 1 : 0);
    }

    if (f) {
      var _e24 = f.getElementsByTagName("Data"),
          _o10 = f.getElementsByTagName("SimpleData");

      for (l = 0; l < _e24.length; l++) {
        a[_e24[l].getAttribute("name")] = t(n(_e24[l], "value"));
      }

      for (l = 0; l < _o10.length; l++) {
        a[_o10[l].getAttribute("name")] = t(_o10[l]);
      }
    }

    T && (a.visibility = t(T)), i.coordTimes.length && (a.coordinateProperties = {
      times: 1 === i.coordTimes.length ? i.coordTimes[0] : i.coordTimes
    });
    var b = {
      type: "Feature",
      geometry: 0 === i.geoms.length ? null : 1 === i.geoms.length ? i.geoms[0] : {
        type: "GeometryCollection",
        geometries: i.geoms
      },
      properties: a
    };
    return e.getAttribute("id") && (b.id = e.getAttribute("id")), b;
  }

  function M(e) {
    var o, s, r, i, l, a, _e25, _t11, _e26, _s6, _i6, _e27, _e28, _t12;

    return _regeneratorRuntime.wrap(function M$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            o = {}, s = {}, r = {}, i = e.getElementsByTagName("Placemark"), l = e.getElementsByTagName("Style"), a = e.getElementsByTagName("StyleMap");

            for (_e25 = 0; _e25 < l.length; _e25++) {
              _t11 = b(A(l[_e25])).toString(16);
              o["#" + l[_e25].getAttribute("id")] = _t11, s[_t11] = l[_e25];
            }

            for (_e26 = 0; _e26 < a.length; _e26++) {
              o["#" + a[_e26].getAttribute("id")] = b(A(a[_e26])).toString(16);
              _s6 = a[_e26].getElementsByTagName("Pair"), _i6 = {};

              for (_e27 = 0; _e27 < _s6.length; _e27++) {
                _i6[t(n(_s6[_e27], "key"))] = t(n(_s6[_e27], "styleUrl"));
              }

              r["#" + a[_e26].getAttribute("id")] = _i6;
            }

            _e28 = 0;

          case 4:
            if (!(_e28 < i.length)) {
              _context3.next = 13;
              break;
            }

            _t12 = L(i[_e28], o, r, s);
            _context3.t0 = _t12;

            if (!_context3.t0) {
              _context3.next = 10;
              break;
            }

            _context3.next = 10;
            return _t12;

          case 10:
            _e28++;
            _context3.next = 4;
            break;

          case 13:
          case "end":
            return _context3.stop();
        }
      }
    }, _marked3);
  }

  e.gpx = function (e) {
    return {
      type: "FeatureCollection",
      features: Array.from(g(e))
    };
  }, e.gpxGen = g, e.kml = function (e) {
    return {
      type: "FeatureCollection",
      features: Array.from(M(e))
    };
  }, e.kmlGen = M, e.tcx = function (e) {
    return {
      type: "FeatureCollection",
      features: Array.from(y(e))
    };
  }, e.tcxGen = y, Object.defineProperty(e, "__esModule", {
    value: !0
  });
});